import { render, staticRenderFns } from "./CoordenadorExpansionItem.vue?vue&type=template&id=33a4c6d2&scoped=true"
import script from "./CoordenadorExpansionItem.vue?vue&type=script&lang=js"
export * from "./CoordenadorExpansionItem.vue?vue&type=script&lang=js"
import style0 from "./CoordenadorExpansionItem.vue?vue&type=style&index=0&id=33a4c6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a4c6d2",
  null
  
)

export default component.exports